<div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <img src="assets/images/closeX.svg">
    </button>
    <div class="d-flex flex-column justify-content-center">
        <img class="modalDietImage" src="assets/images/warning.svg">        
        <div class="regularCopy" innerHTML={{warningCopy}}>{{warningCopy}}</div>
        <button (click)="activeModal.dismiss('Cross click')" class="grayButton">Got it!</button>
    </div>
</div>